import { render } from "./Maquinaria.vue?vue&type=template&id=339d6f9e&scoped=true"
import script from "./Maquinaria.vue?vue&type=script&lang=js"
export * from "./Maquinaria.vue?vue&type=script&lang=js"

import "./Maquinaria.vue?vue&type=style&index=0&id=339d6f9e&scoped=true&lang=scss"
import "./Maquinaria.vue?vue&type=style&index=1&id=339d6f9e&lang=scss&scoped=true"

import exportComponent from "D:\\fromUbuntu2\\fromUbuntu\\ferraro\\ferraro_frontend\\node_modules\\.pnpm\\vue-loader@16.8.3_webpack@4.46.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-339d6f9e"]])

export default __exports__